import type { StateKey } from "@/mocks/gossip";

export interface StateCfg {
  dot: string;
  badge: string;
  icon: string;
}

const cfg: Record<StateKey, StateCfg> = {
  新进展: { dot: "bg-primary-500", badge: "bg-primary-100 text-primary-700", icon: "ri-flashlight-line" },
  补充: { dot: "bg-secondary-400", badge: "bg-secondary-100 text-secondary-800", icon: "ri-add-line" },
  反转: { dot: "bg-accent-500", badge: "bg-accent-100 text-accent-800", icon: "ri-refresh-line" },
  辟谣: { dot: "bg-foreground-300", badge: "bg-foreground-100 text-foreground-600", icon: "ri-check-double-line" },
  存档: { dot: "bg-background-400", badge: "bg-background-200 text-foreground-500", icon: "ri-archive-line" },
};

export function getStateCfg(state: StateKey): StateCfg {
  return cfg[state];
}